'use client'

import { useState } from 'react'

import { ActionToggler, List } from '@/components'

import styles from './AvailableServices.module.scss'

export const AvailableServices = ({ id, services }) => {
  const [isServicesOpen, setIsServicesOpen] = useState(false)

  return (
    <div className={styles.availableServices}>
      <ActionToggler
        text="Ver detalhes"
        isExpanded={isServicesOpen}
        rightIcon="equifax-arrow-down"
        id={`simulation-seeDetails-button--${id}`}
        onClick={() => setIsServicesOpen((prev) => !prev)}
      />

      <div
        className={`
          ${styles.availableServices__services} 
          ${isServicesOpen && styles['availableServices__services--open']}
        `}
      >
        <List items={services} />

        <p className={styles.availableServices__text}>entre outros</p>
      </div>
    </div>
  )
}
